import React from 'react';
type DigitalMicrocopyProps = {
  items: string[];
  tone?: 'dark' | 'light';
  align?: 'left' | 'center';
};
export function DigitalMicrocopy({
  items,
  tone = 'dark',
  align = 'left'
}: DigitalMicrocopyProps) {
  return <p className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px] font-medium ${tone === 'dark' ? 'text-muted' : 'text-ink/70'} ${align === 'center' ? 'justify-center' : 'justify-center sm:justify-start'}`} data-id="element-5" data-mp="gkpe2ledxxre">
      {items.map((item, i) => <React.Fragment key={item} data-id="element-6" data-mp="ul063rrflie5" data-mpi={i}>
          {i > 0 && <span className="text-lime" aria-hidden="true" data-id="element-7" data-mp="uj5gi057t23q">
              •
            </span>}
          <span data-id="element-8" data-mp="zektyqzb8vzm">{item}</span>
        </React.Fragment>)}
    </p>;
}